
import styled from 'styled-components';
import theme from "./../../styles/theme"

export const RecognitionBoxCaroussel = styled.div`
  padding: 35px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  div:first-child{
    display: contents;
  }

`;



export const BoxSize = styled.div`
  align-self: center;
  background: ${theme.colors.white};
  border-radius: 5px;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 1%), 0px 4px 8px rgb(0 0 0 / 2%), 0px 1px 12px rgb(0 0 0 / 12%);
  display: flex;
  flex-direction: column;
  font-family: ${theme.fonts.montSerrat};
  font-size: ${theme.fontSizes.small};
  font-weight: 500;
  justify-content: center;
  margin-top: 40px;
  padding: 20px 40px 40px;
  text-align: left;
  width: 698px;

  div:first-child{
    display: flex;
    justify-content: center;
    margin-top: -5px;
    padding-bottom: 20px;
  }

  @media (max-width:  ${theme.breakpoints.medium}) {
    width: 300px;
    padding: 20px 15px 20px;
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    margin-top: 20px;
  }


`;




